import React from 'react';

import type { IntlShape } from 'react-intl';

import { Empty } from 'antd';

import { ResponsiveTable, type ResponsiveTableColumn } from '@src/components/Table';
import IntlMessages from '@src/util/IntlMessages';

import { getDateTypeIndexUTC } from '../../../../utils';
import styles from '../../../SchedulesDashboard/styles.module.less';
import type { TableDataRow } from '../../../SchedulesDashboard/types';
import type { ScheduleDashboardDateType, TableDataByDay } from '../../types';

interface TasksDetailProps {
  intl: IntlShape;
  tableDataByDay: TableDataByDay[];
  groupBy: ScheduleDashboardDateType;
  columns: ResponsiveTableColumn<TableDataRow>[];
}

/** Detail tab: one table per period. */
const TasksDetail: React.FC<TasksDetailProps> = ({
  intl,
  tableDataByDay,
  groupBy,
  columns,
}) => (
  <>
    <div className={styles.progressItemsList}>
      {tableDataByDay.length === 0 && (
        <Empty description={<IntlMessages id="components.empty.description" />} />
      )}
      {tableDataByDay.map(dayData => (
        <div key={dayData.day} className={styles.dayContainer}>
          <h2 className={styles.day}>{getDateTypeIndexUTC(dayData.day, groupBy, intl)}</h2>
          <ResponsiveTable
            className={styles.table}
            dataSource={dayData.dataSource}
            columns={columns}
            loading={false}
          />
        </div>
      ))}
    </div>
  </>
);

export default TasksDetail;
